import { Link } from 'react-router-dom';
import { findArticle } from '../help/articles';
import type { ReleaseNoteItem } from './releaseNotes';

/**
 * One release note's items: the title in bold, its sentence or two, and "Read more" when a help
 * article explains it. Used by Help > What's New and the What's New pop-up.
 */
export default function ReleaseNoteItems({ items, onOpenArticle }: {
  items: ReleaseNoteItem[];
  /** Called when a "Read more" link is followed (the pop-up closes itself). */
  onOpenArticle?: () => void;
}) {
  return (
    <ul style={{ listStyle: 'none', margin: 0, padding: 0 }}>
      {items.map((item, i) => {
        const article = item.helpArticle ? findArticle(item.helpArticle) : undefined;
        return (
          <li key={`${i}-${item.title}`} style={{ padding: '6px 0' }}>
            <div style={{ fontSize: 'var(--font-size-base)', fontWeight: 600 }}>{item.title}</div>
            <div style={{ fontSize: 'var(--font-size-base)', color: 'var(--text-secondary)', lineHeight: 1.5 }}>
              {item.text}
              {article && (
                <>
                  {' '}
                  <Link
                    to={`/help/${article.slug}`}
                    onClick={onOpenArticle}
                    style={{ color: 'var(--primary-color, #0078d4)', whiteSpace: 'nowrap' }}
                  >
                    Read more<span className="sr-only">: {article.title}</span>
                  </Link>
                </>
              )}
            </div>
          </li>
        );
      })}
    </ul>
  );
}
